// extracted by mini-css-extract-plugin
module.exports = {"actions":"BranchesOfIndustryList_actions__2XtCC","list":"BranchesOfIndustryList_list__1GtIa"};